var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-navigation',[_c('div',{class:_vm.$style.text},[_vm._v(" "+_vm._s(_vm.$t('accessDenied'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }